import React from "react";
import { changeTitle } from "../data/GeneralFunction";

export default function Shop() {
  changeTitle("Findwine | Shop");

  return <div>Shop</div>;
}
